export const DATE_PLACEHOLDER = '5/19/2025';

/** Supported resume export file formats. */
export enum ExportFormat {
  PDF = 'pdf',
  DOCX = 'docx',
}
